module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av247-0a34d3ff2787b70b63713b5c6576b255.jpg";